module.exports = __webpack_public_path__ + "static/media/3_of_hearts.e9ec4e59.png";